export const LOGO_HEIGHT = 60;

export const ARGB_To_RGBA_Color = (x) => {
  if (x?.includes("#")) {
    return x.replace(/#(..)(......)/, "#$2$1");
  }
};
